import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getEvents(companyId, query) {
	return dataTransferWrap(
		ModulesMap.EVENTS,
		dtConfig[ModulesMap.EVENTS].getEvents,
		{
			urlParams: {
				companyId,
			},
			params: query,
		},
	)
}

function getEvent(companyId, eventId) {
	return dataTransferWrap(
		ModulesMap.EVENTS,dtConfig[ModulesMap.EVENTS].getEvent, {
		urlParams: {
			companyId,
			eventId,
		},
	})
}

function getEventPreview(companyId, eventId) {
	return dataTransferWrap(
		ModulesMap.EVENTS,dtConfig[ModulesMap.EVENTS].getEventPreview, {
		urlParams: {
			companyId,
			eventId,
		},
	})
}

function patchEvent(companyId, eventId, data) {
	return dataTransferWrap(
		ModulesMap.EVENTS,dtConfig[ModulesMap.EVENTS].patchEvent, {
		urlParams: {
			companyId,
			eventId,
		},
		...data
	})
}

export default {
	getEvents,
	getEvent,
	getEventPreview,
	patchEvent,
}
